module.exports = __webpack_public_path__ + "static/img/my_vip_bg.448b71b.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/my/my_vip_bg.png
// module id = bBU0
// module chunks = 1